import React, { memo } from 'react'
import clsx from 'clsx'
import { Box, Grid, Paper } from '@material-ui/core'
import SortHandler from '@v4/components/common/SortHandler'
import SignUpForm from '@v4/components/common/Form/SignUpForm'
import Image from '@v4/components/common/Image'
import PropTypes from 'prop-types'
import PageMetaData from '@v4/utils/data/PageMetaData'
import { useForm5 } from './Form5.hooks'

const Form5 = props => {
	const [
		{
			classes,
			withBgImage,
			withMobileImage,
			placeholderColor,
			image,
			direction,
			isMobile,
			formImage,

			title,
			titleKey,
			titleConfig,
			titleEditable,

			buttonText,
			buttonTextKey,
			buttonTextConfig,
			buttonTextEditable,
		},
		{ handleImageClick, handleTitleClick, handleTitleChange, handleButtonClick, handleButtonTextChange },
	] = useForm5(props)

	return (
		<>
			{withBgImage && (
				<Image
					className={clsx(classes.background, 'form5-background')}
					metaData={image}
					isBackground
					onClick={handleImageClick}
				/>
			)}
			<Grid container className={clsx(classes.root, 'form5')}>
				<SortHandler key={isMobile ? 'mobile' : 'desktop'} direction={direction}>
					<Grid item className={clsx(classes.content, 'form5-form-container')}>
						<Paper className={clsx(classes.paper, 'form5-form-card')}>
							<Box className={clsx(classes.form, 'form5-form-wrapper')}>
								<SignUpForm
									placeholderColor={placeholderColor}
									buttonText={buttonText}
									buttonTextConfig={buttonTextConfig}
									buttonTextEditable={buttonTextEditable}
									onButtonTextChange={handleButtonTextChange}
									title={title}
									titleConfig={titleConfig}
									titleEditable={titleEditable}
									usePaperColors
									className="form5-form"
									onTitleClick={handleTitleClick}
									onButtonClick={handleButtonClick}
									onTitleChange={handleTitleChange}
									titleKey={titleKey}
									buttonTextKey={buttonTextKey}
									image={formImage}
								/>
							</Box>
						</Paper>
					</Grid>

					{withMobileImage && (
						<Grid className={clsx(classes.imageGrid, 'banner23-image-grid')} xs={12} item>
							<Box className={classes.mobileImageWrapper}>
								<Image
									className={clsx(classes.mobileImage, 'banner23-image-mobile')}
									metaData={image}
									onClick={handleImageClick}
								/>
							</Box>
						</Grid>
					)}
				</SortHandler>
			</Grid>
		</>
	)
}

Form5.propTypes = {
	metaData: PropTypes.shape({
		backgroundImage: PropTypes.instanceOf(PageMetaData),
		placeholderColor: PropTypes.instanceOf(PageMetaData),
		buttonText: PropTypes.instanceOf(PageMetaData),
		formHeader: PropTypes.instanceOf(PageMetaData),
		mobileImage: PropTypes.instanceOf(PageMetaData),
		mobileImagePosition: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Form5)
